import { useSession } from "@/entities/Session";
import { Navigate } from "react-router-dom";
import { Spinner } from "@/ui";
import { useFlags, useRouter } from "@/utils";
import { RoleController } from "./RoleController";
import { useFlagsmith } from "flagsmith/react";
import { trackUserIdentity } from "@/entities/User";
import { useEffect } from "react";
import { useCompany } from "@/apps/CompanyApp/hooks/useCompany";
import { useApiMutation } from "@/api";
import { acceptCompanyAgreements } from "@/entities/Company";

export function SessionController() {
    const router = useRouter();
    const flagsmith = useFlagsmith();
    const flags = useFlags();
    const session = useSession();
    const { mutate: acceptAgreements } = useApiMutation(
        acceptCompanyAgreements,
    );
    const { company } = useCompany();
    const companyAcceptedAgreements =
        company?.acceptedTos || company?.acceptedPrivacyPolicy;

    useEffect(() => {
        if (flags.ready) {
            trackUserIdentity(company, session.user, flagsmith);
        }
    }, [session.user, flagsmith, flags]);

    useEffect(() => {
        if (company?.uuid && !companyAcceptedAgreements) {
            acceptAgreements({ organizationId: company?.uuid });
        }
    }, [company?.uuid, companyAcceptedAgreements]);

    if (flags.error) {
        console.error("Flagsmith failed to load");
    }

    if ((!flags.ready && !flags.error) || session.isLoading)
        return <Spinner fullScreen testId="session-spinner" />;

    if (session.isHumError) {
        return <Navigate to="/error?type=auth" />;
    }

    if (!session.user || !session.isAuthenticated || session.isError)
        return (
            <Navigate
                to={`/login?returnTo=${(router.search.returnTo as string) || router.asPath}`}
            />
        );

    return <RoleController user={session.user} flags={flags} />;
}
